module.exports = __webpack_public_path__ + "img/45.247937bd.jpg";